//# sourceMappingURL=toast.mjs.map
/// <reference types="./toast.d.mts" />
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";

export function toast(level, message) {
  return $effect.from(
    (_, _1) => {
      let _pipe = $toast.default_options();
      let _pipe$1 = $toast.type_(_pipe, level);
      return $toast.custom(_pipe$1, message);
    },
  );
}
